/**
 * TaskKanbanPage - Página do Kanban de Tarefas
 * 
 * Renderiza o board principal do Kanban com título da página.
 * 
 * @version 1.0.0
 * RELEASE: 2026-04-06 v1.0.0 - Criação inicial
 */

import { TaskKanbanBoard } from '@/components/tasks/TaskKanbanBoard';

export default function TaskKanbanPage() {
  return (
    <div className="flex flex-col h-full">
      <TaskKanbanBoard />
    </div>
  );
}
